import React from "react";
import RFamily from "../../PicesForPages/FHAVAStreamline.jpg";
import FreeConsultation from "../Form/FreeConsultation";
import { Link } from "react-router-dom";

function FhaVaStreamline() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent FhaVaStreamlinePageTopParent">
        <img
          src={RFamily}
          alt="RFamilyImage"
          className="background-video FHAVAStreamlineImage"
        />
        <div className="purchasetopBox FhaVaStreamlinePageTopBox">
          {/* The existing Purchase span */}
          <span>FHA and VA Streamline Refinance</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftHeader">
              Do you have an FHA or VA Loan?
            </span>
            <span className="purchaseBottomLeftContent">
              We’ve got the perfect program for you: the Streamline Program. It
              allows you to skip a monthly mortgage payment and even get cash
              back after closing, potentially putting several hundred dollars in
              your pocket!
            </span>

            <span className="purchaseBottomLeftHeader">
              Check out the advantages:
            </span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>Reduced monthly mortgage payments</li>
              <li>Lower interest rates</li>
              <li>No upfront costs</li>
              <li>No credit check needed</li>
              <li>Available in 15, 20, and 30-year terms</li>
            </ul>

            <span className="purchaseBottomLeftHeader">
              Streamline Refinance
            </span>
            <span className="purchaseBottomLeftContent">
              This refinancing option is similar to the FHA Streamline Program
              and requires minimal documentation. Veterans can also benefit from
              special purchase programs tailored specifically for them.
            </span>

            <div className="purchaseBottomLeftButton">
              <Link
                to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                className="purchaseBottomLeftButtonLink"
              >
                APPLY!
              </Link>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default FhaVaStreamline;
